module.exports = __webpack_public_path__ + "school/img/publication.081a05d1.jpg";